import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from '../../environments/environment';
import { LanguageService } from './language.service';
import { StartupService } from './startup.service';

const COOKIE_FLAGS = 'max-age=7200;secure;samesite=none';

@Injectable({
  providedIn: 'root',
})
export class ModularGoogleAnalyticsService {
  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private startupService: StartupService,
    private languageService: LanguageService
  ) {
    this.startupService.initialized$.subscribe(val => {
      if (val) {
        setTimeout(() => {
          this.setWithCookies('dimension1', this.languageService.currentLanguage);
          this.setWithCookies('dimension2', (!!this.startupService.token).toString());
          this.sendEvent('init', 'init');
        }, 10000);
      }
    });
  }

  public sendPageView(labelName: string) {
    const category = this.getCategory();
    this.pageViewWithCookies('/' + category + '/' + labelName, labelName);
  }

  public sendEvent(action: string, labelName?: string, value?: number) {
    const category = this.getCategory();
    this.eventWithCookies(action, labelName, category, value);
  }

  private getCategory() {
    let category = 'coldroom';
    if (!this.startupService.token) {
      category = 'demo/' + category;
    }
    if (environment.environment !== 'production') {
      category = category + '_' + environment.environment;
    }
    return category;
  }

  private pageViewWithCookies(pagePath: string, pageTitle: string) {
    this.googleAnalyticsService.gtag('config', environment.googleAnalyticsTrackingCode, {
      cookieFlags: COOKIE_FLAGS,
      page_title: pageTitle,
      page_path: pagePath,
    });
  }

  private eventWithCookies(eventName: string, label: string, category: string, value: number) {
    this.googleAnalyticsService.gtag('event', eventName, {
      cookieFlags: COOKIE_FLAGS,
      event_label: label,
      event_category: category,
      event_value: value,
    });
  }

  private setWithCookies(key: string, value: string) {
    const options = {} as any;
    options[key] = value;
    options['cookie_flags'] = COOKIE_FLAGS;
    this.googleAnalyticsService.gtag('set', options);
  }
}
